"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDates = void 0;
const I18nNotInitializedError_1 = require("./I18nNotInitializedError");
const makeDates = (momentFormatsByLanguage, momentLibrary, i18nInstance, lng) => {
    const monthIndexes = {
        JAN: 0,
        FEB: 1,
        MAR: 2,
        APR: 3,
        MAY: 4,
        JUN: 5,
        JUL: 6,
        AUG: 7,
        SEP: 8,
        OCT: 9,
        NOV: 10,
        DEC: 11,
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
        11: 11,
    };
    const weekdayIndexes = {
        SUN: 0,
        MON: 1,
        TUE: 2,
        WED: 3,
        THU: 4,
        FRI: 5,
        SAT: 6,
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
    };
    const initChecker = () => {
        if (!i18nInstance.isInitialized)
            throw new I18nNotInitializedError_1.I18nNotInitializedError();
    };
    const getLng = () => {
        initChecker();
        // if we don't have a lng, this builder is being used for the global lng
        if (lng)
            return lng;
        if (i18nInstance.language)
            return i18nInstance.language;
        throw new Error('i18n global language is not set');
    };
    const localeData = () => {
        return momentLibrary.localeData(getLng());
    };
    return {
        firstDayOfWeek: () => {
            return localeData().firstDayOfWeek();
        },
        monthLabel: (monthIndex) => {
            return localeData().months()[monthIndexes[monthIndex]];
        },
        monthLabels: () => {
            return localeData().months();
        },
        monthShortLabel: (monthIndex) => {
            return localeData().monthsShort()[monthIndexes[monthIndex]];
        },
        monthShortLabels: () => {
            return localeData().monthsShort();
        },
        weekdayLabel: (weekdayIndex) => {
            return localeData().weekdays()[weekdayIndexes[weekdayIndex]];
        },
        weekdayLabels: () => {
            return localeData().weekdays();
        },
        weekdayMinLabel: (weekdayIndex) => {
            return localeData().weekdaysMin()[weekdayIndexes[weekdayIndex]];
        },
        weekdayMinLabels: () => {
            return localeData().weekdaysMin();
        },
        weekdayShortLabel: (weekdayIndex) => {
            return localeData().weekdaysShort()[weekdayIndexes[weekdayIndex]];
        },
        weekdayShortLabels: () => {
            return localeData().weekdaysShort();
        },
        getMomentFormat: (dateFormat) => {
            const mFormat = momentFormatsByLanguage.get(getLng());
            if (mFormat && mFormat[dateFormat]) {
                return mFormat[dateFormat];
            }
            else {
                return dateFormat;
            }
        },
        format: (m, dateFormat) => {
            const language = getLng();
            const mCloned = m.clone().locale(language);
            const mFormat = momentFormatsByLanguage.get(language);
            const formatToUse = mFormat && mFormat[dateFormat] ? mFormat[dateFormat] : dateFormat;
            return mCloned.format(formatToUse);
        },
    };
};
exports.makeDates = makeDates;
//# sourceMappingURL=makeDates.js.map